import { createContext, useContext, useState } from "react";

const CompanyContext = createContext(null);

export const CompanyProvider = ({ children }) => {
  const [company, setCompanyState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("active_company") || "null");
    } catch {
      return null;
    }
  });
  const [companies, setCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(true);

  const setCompany = (nextCompany, reload = false) => {
    setCompanyState(nextCompany || null);
    if (nextCompany?.id) {
      localStorage.setItem("active_company_id", String(nextCompany.id));
      localStorage.setItem("active_company", JSON.stringify(nextCompany));
    } else {
      localStorage.removeItem("active_company_id");
      localStorage.removeItem("active_company");
    }
    if (reload) window.location.reload();
  };

  return (
    <CompanyContext.Provider
      value={{
        company,
        companies,
        companiesLoading,
        setCompany,
        setCompanies,
        setCompaniesLoading,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext);
